export default {
  title: 'Puntos y descuentos',
  store_credit: 'Crédito en tienda',
  points_balance: 'Saldo de puntos',
};
